import { CheckupDto } from "../dtos/checkupDto";
import { Checkup } from "../models/checkup";
import ApiService from "../services/api";
import { Scheduling } from "../models/schedule";
import { AssetSchedulingDto } from "../dtos/assetDto";
import { getAssetIdByChassis } from "../utils/assetUtils";
import { Asset } from "../models/asset";
import { addDeliveryRevision } from "../utils/maintenanceUtils";

export const fetchCheckup = async (checkupId: string): Promise<Checkup | undefined> => {
    const apiService = new ApiService();

    try {
        const response = await apiService.get<any>(`/checkups/${checkupId}`);
        if (response.status === 200) {
            return CheckupDto(response.data);
        } else return undefined;
    } catch (error) {
        console.error(error);
        return undefined;
    }
}

export const fetchCheckupByMetricAndModel = async (odometer: number, hourmeter: number, chassis: string, group: string, model?: string): Promise<Checkup | undefined> => {
    const apiService = new ApiService();

    // Mock chassis
    if (chassis === '-') {
        chassis = '1A2B3C4D5E6F7G8H9';
        group = '4';
    }

    try {
        const response = await apiService.get<any>(`/checkups/by-model-group?odometer=${odometer}&hourMeter=${hourmeter}&chassis=${chassis}&maintenanceGroup=${group}${model ? `&model=${model}` : ''}`);
        if (response.status === 200) {
            return CheckupDto(response.data);
        } else return undefined;
    } catch (error) {
        console.error(error);
        return undefined;
    }
}

export const fetchCheckupsByChassisList = async (chassisList: string[], assets: Asset[]): Promise<{ chassis: string, previous: Scheduling[], next: Scheduling[] }[]> => {
    const apiService = new ApiService();

    try {
        const response = await apiService.post<any>(`/vehicle-checkup/batch`, {
            assets: chassisList
                .filter(Boolean)
                .map(identification => ({ identification, id: getAssetIdByChassis(assets, identification) }))
        });
        if (response.status === 200) {
            return response.data.map((data: any) => {
                const rawInterval = data.nextCheckups[1]?.checkup?.range?.start - data.nextCheckups[0]?.checkup?.range?.start;
                const interval = Number.isFinite(rawInterval) && rawInterval > 0 ? rawInterval : null;
                
                // Encontrar o asset correspondente para obter dados completos
                const asset = assets.find(asset => asset.chassis === data.chassis);
                
                // Dados básicos do vehicle para o AssetSchedulingDto
                const vehicleData = {
                    assetId: asset?.id || '',
                    name: asset?.name || '',
                    vehicleModel: asset?.model || '',
                    chassis: asset?.chassis || data.chassis || '',
                    odometer: asset?.odometer || 0,
                    hourMeter: asset?.hourmeter || 0,
                    vehicleYear: asset?.year || 0,
                    plate: asset?.licensePlate || '-',
                    vehicleGroup: asset?.groupName || '',
                    vehicleGroupId: asset?.group || '',
                };

                // TODO: get technical revision from ChecklistFacil
                let [previousCheckups, nextCheckups] = [data.previousCheckups, data.nextCheckups];
                if (data.previousCheckups.length > 0) {
                    previousCheckups = addDeliveryRevision(previousCheckups);
                } else {
                    nextCheckups = addDeliveryRevision(nextCheckups);
                }
                
                return {
                    chassis: data.chassis,
                    previous: previousCheckups?.map((checkup: any) => AssetSchedulingDto({
                        ...checkup,
                        isFinished: checkup.finished !== undefined ? checkup.finished : true,
                        vehicle: vehicleData, // Passar dados completos do vehicle
                        checkup: {
                            name: checkup.title,
                            checkupType: checkup.title,
                            range: {
                                start: checkup.checkup?.range?.start || (checkup.schedule?.odometer ? (interval ? Math.floor(checkup.schedule?.odometer / interval) * interval : checkup.schedule?.odometer) : null),
                                end: checkup.checkup?.range?.start ? checkup.checkup?.range?.start + interval : null,
                            },
                        }
                    })) ?? [],
                    next: nextCheckups?.map((checkup: any) => AssetSchedulingDto({
                        ...checkup,
                        isFinished: checkup.finished !== undefined ? checkup.finished : false,
                        vehicle: vehicleData, // Passar dados completos do vehicle
                        checkup: {
                            name: checkup.title,
                            checkupType: checkup.title,
                            range: checkup.checkup?.range,
                        }
                    })) ?? [],
                }
            });
        } else return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}